<template>
  <span>
    <b-button
      variant="v3_teal_outline"
      class=""
      @click="isModalOpen = true"
    >
      <span class="d-inline-flex align-items-center">
        Set ICO Alert Rules
      </span>
    </b-button>
    <portal to="additional-popups">
      <modal-re-init-modal-behaviour>
        <template slot-scope="{ keyId, keyUpdater }">
          <b-modal
            modal-class="v3_modal ico-alert-class"
            :visible="isModalOpen"
            hide-footer
            size="xl"
            @show="keyUpdater"
            @hidden="isModalOpen = false"
          >
            <template slot="modal-header-close">
              <span>Close window</span>
              <i class="mdi mdi-close-circle-outline" />
            </template>
            <div
              class="font_size_1000rem font_weight_bold v3_color_black_knight"
            >
              Set Your ICO Alert Preferences
            </div>
            <ico-alerts-form
              :key="keyId"
              @cancel="isModalOpen = false"
              @saved="onAlertPreferencesSaved"
            />
          </b-modal>
        </template>
      </modal-re-init-modal-behaviour>
    </portal>
  </span>
</template>

<script>
import IcoAlertsForm from '@/components/dashboard/ico-alerts/IcoAlertsForm';
import ModalReInitModalBehaviour from '@/behaviours/ForceUpdateBehaviour';

export default {
  name: 'IcoAlertsButtonModal',
  components: {
    IcoAlertsForm,
    ModalReInitModalBehaviour,
  },
  data: function () {
    return {
      isModalOpen: false,
    };
  },
  methods: {
    onAlertPreferencesSaved: function () {
      this.$toasted.success('ICO Alerts saved', { duration: 3000 });
      this.isModalOpen = false;
    },
  },
};
</script>

<style>
@media (min-width:320px) and (max-width: 575px) {
  .ico-alert-class .modal-body{
    padding-left: 45px;
    padding-right: 45px;
  }
}
@media (min-width:320px) and (max-width: 768px) {
  .ico-alert-class .border_left_1{
    border-left: unset !important;
  }
  .mobile-version{
    display: block !important;
  }
  .mobile-version .btn{
    width: 100%;
    margin-left: unset !important;
    margin-top: 10px;
    flex-direction:column;
  }
}
@media (min-width:768px) and (max-width: 992px){
  .ico-alert-class .modal-dialog{
    max-width: 650px;
  }
}
</style>
